import { NavigateFunction, To } from 'react-router';

import {
  popNetworkRequestUUID,
  pushNetworkRequestUUID,
} from '@core/store/appSlice/appSlice';
import { store } from '@core/store/store';
import { DemmiLogType, Logger } from '@subhanhabib/demmilib';

import packageJson from '../../package.json';

export const demmiRequest = async <T>(
  request: Promise<T>,
  options?: { mockDelay?: boolean; logMessages?: string[] },
): Promise<T> => {
  const requestUUID = crypto.randomUUID();
  store.dispatch(pushNetworkRequestUUID(requestUUID));
  return request
    .catch(e => {
      Logger(
        {
          objs: {
            uuid: requestUUID,
            logMessages: options?.logMessages,
            request,
            e,
          },
          type: DemmiLogType.error,
          collapsed: true,
        },
        demmiRequest,
      );
      setTimeout(() => store.dispatch(popNetworkRequestUUID(requestUUID)), 200);
      return Promise.reject(e);
    })
    .then(async res => {
      if (options?.mockDelay) await new Promise(res => setTimeout(res, 50000)); // fake sleep
      // Delay by 100ms to allow chained requests to keep loading indicator active
      setTimeout(() => store.dispatch(popNetworkRequestUUID(requestUUID)), 200);
      return res;
    });
};

export const navigateTransitioned = ({
  to,
  navigate,
  search,
}: {
  to: To;
  navigate: NavigateFunction;
  search?: { [key: string]: string };
}) => {
  const supportsViewTransitions = !!document.startViewTransition;
  navigate(search ? routeWithSearch({ route: to.toString(), search }) : to, {
    viewTransition: supportsViewTransitions,
  });
};

export const routeWithSearch = ({
  route,
  search,
}: {
  route: string;
  search: { [key: string]: string };
}) => {
  Logger({ objs: { search } }, routeWithSearch);
  return `${route}?${Object.entries(search)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')}`;
};

export const getAppVersion = () => packageJson.version;
export const getAppDate = () => packageJson.date;

export const isProd = () => {
  const URL_PARAM_PROD = 'forceProd';
  const urlParams = new URLSearchParams(window.location.search);
  return process.env.IS_PRODUCTION || urlParams.has(URL_PARAM_PROD);
};
